var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"googleRating",style:(`height:${_vm.height}px; background-size: ${_vm.height}px; width: ${_vm.base * _vm.height}px`)},[_c('span',{staticClass:"googleRating--fill",style:(`width: ${_vm.percent}%; height: ${_vm.height}px; background-size: ${_vm.height}px`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }